import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface GenericTableSkeletonProps {
  children: React.ReactNode;

  rows?: number;

  rowHeight?: number;

  cellGap?: number;

  containerSx?: object;
}

const GenericTableSkeleton: React.FC<GenericTableSkeletonProps> = ({
  children,
  rows = 5,
  rowHeight = 24,
  cellGap = 16,
  containerSx = {},
}) => {
  const columnCount = React.Children.toArray(children).length;

  if (columnCount === 0) {
    return (
      <Box sx={{ p: 2, ...containerSx }}>
        <Skeleton variant="rectangular" width="100%" height={40} />
        <Skeleton variant="rectangular" width="100%" height={40} sx={{ mt: 1 }} />
      </Box>
    );
  }

  return (
    <Box width="100%" sx={containerSx}>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Box
          key={rowIndex}
          display="flex"
          alignItems="center"
          px={2}
          py={1}
          borderBottom="1px solid rgba(224, 224, 224, 1)"
          sx={{ '&:last-child': { borderBottom: 'none' } }}
        >
          {Array.from({ length: columnCount }).map((_, colIndex) => (
            <Skeleton
              key={colIndex}
              variant="text"
              height={rowHeight}
              width="100%"
              sx={{
                flex: 1,
                mr: colIndex < columnCount - 1 ? `${cellGap}px` : 0,
              }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default GenericTableSkeleton;
